import type { CampaignRunStatus, EmailCampaignStatus } from '../../types/campaign';

type Status = EmailCampaignStatus | CampaignRunStatus;

const LABEL: Record<Status, string> = {
  DRAFT: 'Draft',
  SCHEDULED: 'Scheduled',
  SENDING: 'Sending',
  SENT: 'Sent',
  CANCELED: 'Canceled',
  QUEUED: 'Queued',
  RUNNING: 'Running',
  SUCCESS: 'Success',
  PARTIAL: 'Partial',
  FAILED: 'Failed',
};

const COLOR: Record<Status, string> = {
  DRAFT: 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400',
  SCHEDULED: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300',
  SENDING: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300',
  SENT: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300',
  CANCELED: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300',
  QUEUED: 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400',
  RUNNING: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300',
  SUCCESS: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300',
  PARTIAL: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300',
  FAILED: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300',
};

interface CampaignStatusChipProps {
  status: Status;
}

/**
 * Small rounded status chip for a campaign's lifecycle state. Shared between
 * the campaigns list (Campaigns.tsx), the composer (CampaignComposer.tsx),
 * and the run detail modal so the color/label mapping only lives in one
 * place.
 */
export function CampaignStatusChip({ status }: CampaignStatusChipProps) {
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${COLOR[status]}`}>
      {LABEL[status]}
    </span>
  );
}
